"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
function login(payload) {
    return { type: constants_1.ACTIONS.Authentication.LOGIN, payload };
}
exports.login = login;
function updateOrganization() {
    return { type: constants_1.ACTIONS.Authentication.UPDATE_ORG };
}
exports.updateOrganization = updateOrganization;
function updateOrganizationByAccessToken() {
    return { type: constants_1.ACTIONS.Authentication.UPDATE_ORG_BY_ACCESSTOKEN };
}
exports.updateOrganizationByAccessToken = updateOrganizationByAccessToken;
function updateOrganizationSuccess(payload) {
    return { type: constants_1.ACTIONS.Authentication.UPDATE_ORG_SUCCESS, payload };
}
exports.updateOrganizationSuccess = updateOrganizationSuccess;
function register(payload) {
    return { type: constants_1.ACTIONS.Authentication.REGISTER, payload };
}
exports.register = register;
function registerOrg(payload) {
    return { type: constants_1.ACTIONS.Authentication.REGISTER_ORG, payload };
}
exports.registerOrg = registerOrg;
function loginSuccess(payload) {
    return { type: constants_1.ACTIONS.Authentication.LOGIN_SUCCESS, payload };
}
exports.loginSuccess = loginSuccess;
function loginFailed(payload) {
    return { type: constants_1.ACTIONS.Authentication.LOGIN_FAILED, payload };
}
exports.loginFailed = loginFailed;
function setTimezone(timezone) {
    return { type: constants_1.ACTIONS.Authentication.TIME_ZONE, payload: timezone };
}
exports.setTimezone = setTimezone;
// Logout actions
function logoutUser() {
    return { type: constants_1.ACTIONS.Authentication.LOGOUT };
}
exports.logoutUser = logoutUser;
function deleteState() {
    return { type: constants_1.ACTIONS.Authentication.DELETE_STATE };
}
exports.deleteState = deleteState;
function registerSuccess(payload) {
    return { type: constants_1.ACTIONS.Authentication.REGISTER_SUCCESS, payload };
}
exports.registerSuccess = registerSuccess;
function registerFailed(payload) {
    return { type: constants_1.ACTIONS.Authentication.REGISTER_FAILED, payload };
}
exports.registerFailed = registerFailed;


//////////////////
// WEBPACK FOOTER
// ./client/src/authentication/AuthenticationActions.ts
// module id = 608
// module chunks = 0 1 2